/**
 * TCSB application constants and API route map.
 * API routes match CON-002 exactly. Do not add routes not listed in CON-002.
 */

// ── App constants ──────────────────────────────────────────────────────────
export const APP_NAME = "Twin City Silver Bullet";
export const APP_TAGLINE = "Winston-Salem's Favorite Coffee Truck";

/**
 * SPR-014 T-007 — single source of truth for the online-ordering launch flag.
 * Online ordering/checkout is disabled at launch (cart/checkout removed in T-003).
 * While this is `false`, the temporary <ComingSoonBadge> notice is shown.
 * SPR-013 flips this to `true` (or deletes the badge + usages) to re-enable.
 * Greppable removal point: `ONLINE_ORDERING_ENABLED`.
 */
export const ONLINE_ORDERING_ENABLED = false;

export const NOTIFICATION_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
};

export const SORT_DIRECTIONS = {
  ASCENDING: "ASC",
  DESCENDING: "DESC",
};

export const DISPLAY_PER_PAGE = 25;

// ── API route map (CON-002) ────────────────────────────────────────────────

/**
 * All API routes for TCSB. Must match CON-002 exactly.
 * Dynamic routes are functions: e.g. API.MENU.DETAIL(3) → "/api/menu/3"
 */
export const API = {
  AUTH: {
    LOGIN: "/auth/login",
    REFRESH: "/auth/refresh",
    LOGOUT: "/auth/logout",
    CHANGE_PASSWORD: "/auth/change-password",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
  },

  PROFILE: {
    GET: "/profile",
    UPDATE: "/profile",
  },

  MENU: {
    LIST: "/menu",
    DETAIL: (id) => `/menu/${id}`,
  },

  VEHICLES: {
    LIST: "/vehicles",
    DETAIL: (id) => `/vehicles/${id}`,
  },

  EVENTS: {
    LIST: "/events",
    DETAIL: (id) => `/events/${id}`,
  },

  ORDERS: {
    CREATE: "/orders",
    DETAIL: (id) => `/orders/${id}`,
  },

  BOOKINGS: {
    CREATE: "/bookings",
  },

  ADMIN: {
    MENU: {
      LIST: "/admin/menu",
      CREATE: "/admin/menu",
      DETAIL: (id) => `/admin/menu/${id}`,
      UPDATE: (id) => `/admin/menu/${id}`,
      DELETE: (id) => `/admin/menu/${id}`,
      // SPR-009 / BLU-007 — menu-item image (SAS client-direct upload)
      IMAGE_UPLOAD_URL: (id) => `/admin/menu/${id}/image/upload-url`,
      IMAGE_SET: (id) => `/admin/menu/${id}/image`,
      IMAGE_DELETE: (id) => `/admin/menu/${id}/image`,
    },
    CATEGORIES: {
      LIST: "/admin/categories",
      CREATE: "/admin/categories",
      UPDATE: (id) => `/admin/categories/${id}`,
      DELETE: (id) => `/admin/categories/${id}`,
    },
    VEHICLES: {
      LIST: "/admin/vehicles",
      CREATE: "/admin/vehicles",
      DETAIL: (id) => `/admin/vehicles/${id}`,
      UPDATE: (id) => `/admin/vehicles/${id}`,
      DELETE: (id) => `/admin/vehicles/${id}`,
    },
    EVENTS: {
      LIST: "/admin/events",
      CREATE: "/admin/events",
      DETAIL: (id) => `/admin/events/${id}`,
      UPDATE: (id) => `/admin/events/${id}`,
      DELETE: (id) => `/admin/events/${id}`,
    },
    USERS: {
      LIST: "/admin/users",
      CREATE: "/admin/users",
      UPDATE: (id) => `/admin/users/${id}`,
      DELETE: (id) => `/admin/users/${id}`,
    },
  },

  HEALTH: "/health",
};

const constants = {
  APP_NAME,
  APP_TAGLINE,
  ONLINE_ORDERING_ENABLED,
  NOTIFICATION_TYPES,
  SORT_DIRECTIONS,
  DISPLAY_PER_PAGE,
  API,
};

export default constants;
